"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lq_exports = {};
__export(lq_exports, {
  LiveQueries: () => LiveQueries
});
module.exports = __toCommonJS(lq_exports);
var import_fast_equals = require("fast-equals");
var import_query = require("./messages/query");
var import_query2 = require("./notifications/query");
var import_query3 = require("./notification-contexts/query");
var import_query4 = require("./label/query");
var import_query5 = require("./collaborators/query");
const maxQueriesCache = 100;
class LiveQueries {
  constructor(client, workspace, filesUrl) {
    this.client = client;
    this.workspace = workspace;
    this.filesUrl = filesUrl;
    this.client.onEvent = (event) => {
      this.eventQueue = this.eventQueue.then(() => this.onEvent(event)).catch((err) => {
        console.error("Error handling event:", err);
      });
    };
    this.client.onRequest = (event, promise) => {
      void this.onRequest(event, promise);
    };
  }
  static {
    __name(this, "LiveQueries");
  }
  queries = /* @__PURE__ */ new Map();
  unsubscribed = /* @__PURE__ */ new Set();
  counter = 0;
  eventQueue = Promise.resolve();
  async onEvent(event) {
    await Promise.all(Array.from(this.queries.values()).map((q) => q.onEvent(event)));
  }
  async onRequest(event, promise) {
    for (const q of this.queries.values()) {
      void q.onRequest(event, promise);
    }
  }
  queryMessages(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      import_query.MessagesQuery,
      (params2) => this.findMessagesQuery(params2)
    );
  }
  queryNotifications(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      import_query2.NotificationQuery,
      (params2) => this.findNotificationQuery(params2)
    );
  }
  queryNotificationContexts(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      import_query3.NotificationContextsQuery,
      (params2) => this.findNotificationContextsQuery(params2)
    );
  }
  queryLabels(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      import_query4.LabelsQuery,
      (params2) => this.findLabelsQuery(params2)
    );
  }
  queryCollaborators(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      import_query5.CollaboratorsQuery,
      (params2) => this.findCollaboratorsQuery(params2)
    );
  }
  createAndStoreQuery(params, callback, QueryClass, finder) {
    const query = this.findOrCreateQuery(params, callback, QueryClass, finder);
    this.queries.set(query.id, query);
    return {
      unsubscribe: /* @__PURE__ */ __name((force) => {
        this.unsubscribeQuery(query, force);
      }, "unsubscribe")
    };
  }
  findOrCreateQuery(params, callback, QueryClass, finder) {
    const id = ++this.counter;
    const exists = finder(params);
    if (exists !== void 0) {
      if (this.unsubscribed.has(exists.id)) {
        this.unsubscribed.delete(exists.id);
        exists.setCallback(callback);
        return exists;
      } else {
        const result = exists.copyResult();
        return new QueryClass(this.client, this.workspace, this.filesUrl, id, params, callback, result);
      }
    }
    return new QueryClass(this.client, this.workspace, this.filesUrl, id, params, callback);
  }
  findQuery(params, QueryClass) {
    for (const query of this.queries.values()) {
      if (query instanceof QueryClass && this.queryCompare(params, query.params)) {
        return query;
      }
    }
  }
  findMessagesQuery(params) {
    return this.findQuery(params, import_query.MessagesQuery);
  }
  findNotificationQuery(params) {
    return this.findQuery(params, import_query2.NotificationQuery);
  }
  findNotificationContextsQuery(params) {
    return this.findQuery(params, import_query3.NotificationContextsQuery);
  }
  findLabelsQuery(params) {
    return this.findQuery(params, import_query4.LabelsQuery);
  }
  findCollaboratorsQuery(params) {
    return this.findQuery(params, import_query5.CollaboratorsQuery);
  }
  queryCompare(q1, q2) {
    return Object.keys(q1).length === Object.keys(q2).length && (0, import_fast_equals.deepEqual)(q1, q2);
  }
  removeOldQueries() {
    const unsubscribed = Array.from(this.unsubscribed);
    for (let i = 0; i < this.unsubscribed.size / 2; i++) {
      const id = unsubscribed.shift();
      if (id === void 0) return;
      this.unsubscribe(id);
    }
  }
  unsubscribe(id) {
    const query = this.queries.get(id);
    if (query == null) return;
    void query.unsubscribe();
    this.queries.delete(id);
    this.unsubscribed.delete(id);
  }
  unsubscribeQuery(query, force = false) {
    this.unsubscribed.add(query.id);
    query.removeCallback();
    if (this.unsubscribed.size > maxQueriesCache) {
      this.removeOldQueries();
    }
    if (force) {
      this.unsubscribe(query.id);
    }
  }
  close() {
    this.queries.clear();
    this.unsubscribed.clear();
  }
  async refresh() {
    for (const [id, query] of this.queries.entries()) {
      if (this.unsubscribed.has(id)) {
        this.unsubscribe(id);
        continue;
      }
      try {
        await query.refresh();
      } catch (e) {
        console.error("Failed to refresh live query", e, query.id, query.params);
      }
    }
  }
}
//# sourceMappingURL=lq.js.map
